













































































import { Component, Prop, Vue } from "vue-property-decorator";
import { isEmail, isPhone } from "@/utils";

@Component
export default class Password extends Vue {
  @Prop(String) readonly publicId!: string;
  resetVerified = false;
  emailOrPhone = "";
  password = "";
  passwordConf = "";
  async requestReset() {
    const { emailOrPhone } = this;
    if (!emailOrPhone) {
      return;
    }
    const email = isEmail(emailOrPhone) ? emailOrPhone : null;
    const phone = isPhone(emailOrPhone) ? emailOrPhone : null;
    if (!email && !phone) {
      this.$modal.show("dialog", {
        title: "WaitingMed",
        text: "Invalid email or phone.",
      });
      return;
    }
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch("auth/requestPasswordReset", {
        email,
        phone,
      });
      if (data.result === "OK") {
        let text = "Thank you!<br/><br/>We have sent you ";
        if (email) {
          if (phone) {
            text += "an email and a text message. Please check your inboxes ";
          } else {
            text += "an email. Please check your inbox ";
          }
        } else {
          text += "a text message. Please check your inbox ";
        }
        text += "and follow the instructions.";
        this.$modal.show("dialog", {
          title: "WaitingMed",
          text,
        });
        this.emailOrPhone = "";
        this.$router.push("/login");
      } else if (data.result === "USER_NOT_FOUND") {
        this.$modal.show("dialog", {
          title: "WaitingMed",
          text: "We can't find a user account with the provided information.",
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async verifyReset() {
    this.$store.commit("main/SET_LOADING", true);
    try {
      const data = await this.$store.dispatch(
        "auth/verifyPasswordReset",
        this.publicId
      );
      this.resetVerified = data.isValid;
      console.log(data);
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  async resetPassword() {
    const { publicId, password, passwordConf } = this;
    if (!password || !(password === passwordConf)) {
      return;
    }
    this.$store.commit("main/SET_LOADING", true);
    try {
      await this.$store.dispatch("auth/resetPassword", {
        publicId,
        password,
      });
      this.password = "";
      this.passwordConf = "";
      this.$modal.show("dialog", {
        title: "WaitingMed",
        text:
          "Thank you!<br/><br/>Your password has been set. You may proceed to login.",
      });
      this.$router.push("/login");
    } catch (error) {
      console.log(error);
    } finally {
      this.$store.commit("main/SET_LOADING", false);
    }
  }
  get isRequest() {
    return !this.publicId || !this.resetVerified;
  }
  mounted() {
    if (this.publicId) this.verifyReset();
  }
}
